import { TicketingFormCategory } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { getPrefilledTitle } from "@/features/LiveFormEditor/common/prefillDataBuilders/getPrefilledTitle";

export const usePrefilledTitle = (formCategory: TicketingFormCategory) => {
  const { organization } = useCurrentUserContext();
  const { t } = useTranslate();

  return getPrefilledTitle(formCategory, t, organization);
};
